import React, { useContext } from 'react';
import { Overlay } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
const { arrayOf, bool, func, node, string, oneOfType, oneOf } = proptypes;
import { EPCContext } from '../epc/contexts/epcContext';

const MobileAwareOverlay = ({
  children,
  className,
  closeButton = true,
  el = 'div',
  fit = true,
  header,
  medium = true,
  modalClass,
  onClose,
  open = true,
  placement,
  positionedCloseButton = true,
  scrollable = true
}) => {

  const { isMobile } = useContext(EPCContext);

  return (
    <Overlay
      className={className}
      closeButton={closeButton}
      el={el}
      fit={fit}
      header={header}
      medium={medium}
      modalClass={modalClass}
      onClose={onClose}
      open={open}
      placement={placement}
      positionedCloseButton={positionedCloseButton && !isMobile}
      scrollable={scrollable}
    >
      {children}
    </Overlay>
  );
};

MobileAwareOverlay.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  className: string,
  closeButton: bool,
  el: string,
  fit: bool,
  header: string,
  medium: bool,
  modalClass: string,
  onClose: func.isRequired,
  open: bool,
  scrollable: bool,
  placement: oneOf(['right', 'left']),
  positionedCloseButton: bool
};
MobileAwareOverlay.defaultProps = {
  children: null,
  className: null,
  closeButton: true,
  el: 'div',
  fit: true,
  header: null,
  medium: true,
  modalClass: null,
  open: true,
  scrollable: true,
  placement: 'right',
  positionedCloseButton: true
};

export { MobileAwareOverlay };
